import Header from "@components/Header";
import { Box } from "@pingux/astro";
import { DIMENSIONS } from "@assets/styles/styleConstants";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const mainContainer = {
    height: "100%",
    width: "100%",
    bg: "white",
    alignItems: "center",
    justifyItems: "center",
    justifyContent: "center",
  };

  const childrenWrapper = {
    paddingTop: DIMENSIONS?.headerHeight,
    maxWidth: "1540px",
    width: "100%",
    px: ["1.5rem", null, null, null, null, null],
    flexGrow: "1",
  };

  return (
    <>
      <Header />
      <Box as="main" sx={mainContainer}>
        <Box sx={childrenWrapper}>
          {children}
        </Box>
      </Box>
    </>
  );
};

export default Layout;
